<div class="onboarding">
  <edu-card>
    @if (student) {
      <div class="student-info">
        <h2 edu-card-title>{{ student.userName }} - {{ student.fullName }}</h2>
      </div>
    }
    @if (!student) {
      <div class="onboarding-title">
        <h2 edu-card-title>Onboarding Steps</h2>
      </div>
    }
    <div class="onboarding-steps">
      @if (onboardingSteps && onboardingSteps.length > 0) {
        @for (step of onboardingSteps; track step; let i = $index) {
          <div
            class="step-wrapper"
            >
            <!-- Timeline -->
            <div class="timeline">
              <div
                class="circle"
                [ngClass]="{ completed: step.completed, pending: !step.completed }"
              ></div>
              @if (i < onboardingSteps.length - 1) {
                <div
                  class="line"
                  [ngClass]="{ completed: onboardingSteps[i + 1]?.completed }"
                ></div>
              }
            </div>
            <!-- Step content: Use ng-template for admin/student view -->
            @if (viewType === 'admin') {
              <div class="step step-disabled">
                <div class="step-info">
                  @if (step.completedAt) {
                    <p class="completed-at">
                      {{ step.completedAt | date: "dd MMM yy" }}
                    </p>
                  }
                  <h3 class="step-name">{{ step.step.name }}</h3>
                  <p class="step-description">{{ step.step.description }}</p>
                </div>
                <div class="step-status">
                  <span
                  [ngClass]="{
                    completed: step.completed,
                    pending: !step.completed,
                  }"
                    >
                    {{ step.completed ? "Completed" : "Pending" }}
                  </span>
                  <!-- No icon and no icon-placeholder for admin view -->
                </div>
                @if (i < onboardingSteps.length - 1) {
                  <mat-divider
                    class="step-divider"
                  ></mat-divider>
                }
              </div>
            } @else {
              <div class="step" (click)="onclickstep()">
                <div class="step-info">
                  @if (step.completedAt) {
                    <p class="completed-at">
                      {{ step.completedAt | date: "dd MMM yy" }}
                    </p>
                  }
                  <h3 class="step-name">{{ step.step.name }}</h3>
                  <p class="step-description">{{ step.step.description }}</p>
                </div>
                <div class="step-status">
                  <span
                  [ngClass]="{
                    completed: step.completed,
                    pending: !step.completed,
                  }"
                    >
                    {{ step.completed ? "Completed" : "Pending" }}
                  </span>
                  @if (!step.completed) {
                    <mat-icon
                      fontIcon="keyboard_arrow_right"
                      aria-label="Go to step"
                    ></mat-icon>
                  }
                  @if (step.completed) {
                    <div class="icon-placeholder"></div>
                  }
                </div>
                @if (i < onboardingSteps.length - 1) {
                  <mat-divider
                    class="step-divider"
                  ></mat-divider>
                }
              </div>
            }
          </div>
        }
      } @else {
        <div class="empty-onboarding">
          <img src="assets/meetings/no-meetings.svg" alt="No onboarding steps" />
          <p>No onboarding steps to display.</p>
        </div>
      }
    </div>
  </edu-card>
</div>
